import React from 'react';
import './ContactSection.css';

const ContactSection = () => {
  const email = 'swayamhomesprivatelimited@gmail.com';
  const phone = '9297971919';
  const whatsappMessage = 'Hi Swayam Homes! I am interested in learning more about your projects.';
  const whatsappLink = `https://wa.me/91${phone}?text=${encodeURIComponent(whatsappMessage)}`;

  const contactMethods = [
    {
      id: 1,
      icon: '📱',
      title: 'WhatsApp',
      description: 'Connect instantly',
      action: 'Start Chat',
      link: whatsappLink,
      color: 'whatsapp'
    },
    {
      id: 2,
      icon: '📧',
      title: 'Email',
      description: 'Send us an email',
      action: 'Send Email',
      link: `mailto:${email}`,
      color: 'email'
    },
    {
      id: 3,
      icon: '☎️',
      title: 'Phone',
      description: 'Call us directly',
      action: 'Call Now',
      link: `tel:+91${phone}`,
      color: 'phone'
    }
  ];

  return (
    <section className="contact-section">
      {/* Eyebrow */}
      <div className="contact-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Get In Touch</span>
        <div className="eyebrow-line"></div>
      </div>

      <h2 className="contact-title">Let's Connect</h2>
      <p className="contact-subtitle">
        Ready to explore your dream home? Reach out to us through your preferred channel
      </p>

      {/* Contact Methods Grid */}
      <div className="contact-grid">
        {contactMethods.map((method) => (
          <a
            key={method.id}
            href={method.link}
            target={method.id === 1 ? '_blank' : '_self'}
            rel={method.id === 1 ? 'noopener noreferrer' : ''}
            className={`contact-card ${method.color}`}
          >
            <div className="contact-icon">{method.icon}</div>
            <h3 className="contact-title-card">{method.title}</h3>
            <p className="contact-desc">{method.description}</p>
            
            {method.id === 1 && <p className="contact-detail">+91 {phone}</p>}
            {method.id === 2 && <p className="contact-detail">{email}</p>}
            {method.id === 3 && <p className="contact-detail">+91 {phone}</p>}
            
            <span className="contact-action">{method.action} →</span>
          </a>
        ))}
      </div>

      {/* Quick Info */}
      <div className="quick-info">
        <div className="info-item">
          <span className="info-icon">📍</span>
          <div>
            <p className="info-label">Serving Premium Locations</p>
            <p className="info-value">Hyderabad & Surrounding Areas</p>
          </div>
        </div>

        <div className="info-item">
          <span className="info-icon">⏰</span>
          <div>
            <p className="info-label">Response Time</p>
            <p className="info-value">Within 24 Hours</p>
          </div>
        </div>

        <div className="info-item">
          <span className="info-icon">✓</span>
          <div>
            <p className="info-label">Customer Support</p>
            <p className="info-value">Available 7 Days a Week</p>
          </div>
        </div>
      </div>

      {/* CTA Banner */}
      <div className="contact-banner">
        <h3>Have Questions?</h3>
        <p>Our expert team is here to guide you through every step of your real estate journey.</p>
        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-btn">
          💬 Start WhatsApp Chat
        </a>
      </div>
    </section>
  );
};

export default ContactSection;
